"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Label = ({ id, text, required }) => {
    return (react_1.default.createElement("label", { htmlFor: id, className: "block pr-2 dark:text-gray-500 text-gray-700 text-sm font-medium leading-5" },
        text,
        required && react_1.default.createElement("span", { className: 'text-highlight-500' }, "*")));
};
exports.default = Label;
